export default __webpack_public_path__ + "static/media/joinMemberBgEn.02d6ee0c.png";